/**
 * Formatting helpers. Currency comes from the backend payload, the locale from
 * the active i18n language - no hand-built number or date formats.
 */
export const formatMoneyCents = (
  cents: number,
  currency: string,
  locale: string,
): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(cents / 100);

export const formatNumber = (value: number, locale: string): string =>
  new Intl.NumberFormat(locale).format(value);

export const formatDate = (isoDate: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, { dateStyle: "long" }).format(
    new Date(isoDate),
  );

/**
 * Date and time of an instant as two strings, both in German time: the
 * contract is with a German provider, and a receipt that showed a different
 * day depending on the viewer's device would be a second version of the fact.
 */
export const formatDateAndTimeInBerlin = (
  isoInstant: string,
  locale: string,
): { date: string; time: string } => {
  const instant = new Date(isoInstant);

  return {
    date: new Intl.DateTimeFormat(locale, {
      dateStyle: "long",
      timeZone: "Europe/Berlin",
    }).format(instant),
    time: new Intl.DateTimeFormat(locale, {
      timeStyle: "short",
      timeZone: "Europe/Berlin",
    }).format(instant),
  };
};
